import axios, { AxiosPromise } from 'axios';
import { IBrand } from '../../../@types/model/masterData/brand/brand';
import { IBrandUpsert } from '../../../@types/model/masterData/brand/brandUpsert';

export default class BrandHttpService {
    public static getBrandData() : AxiosPromise<Array<IBrand>> {
        return axios.get(`${API_URL}/v1/Brand/GetAllWeb`);
    }

    public static addOrUpdateBrand(upsert : IBrandUpsert) : AxiosPromise<IBrand> {
        return axios.post(`${API_URL}/v1/Brand/PostBrand`, upsert);
    }

    public static deleteBrand(brandId : number) : AxiosPromise<IBrand> {
        return axios.delete(`${API_URL}/v1/Brand/Delete`, {
            params : { brandId },
        });
    }
}
